import React, { useEffect, useState } from "react";
import { XCircleIcon } from "@heroicons/react/outline";
import "react-phone-input-2/lib/style.css";
import { IoMdArrowDropdownCircle } from "react-icons/io";
import {
  Card,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useGetSmscListMutation } from "Services/services";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import hasPermission from "pages/Permissions";

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: "btn btn-secondary me-3",
      cancelButton: "btn btn-gray",
    },
    buttonsStyling: false,
  })
);

export default () => {
  const [tableData, setTableData] = useState([]);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 2000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    fetchTableData();
  }, [debouncedValue]);

  const [getList] = useGetSmscListMutation();
  const fetchTableData = () => {
    getList()
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.smsc_monitoring || []);
          // setTotalPosts(response?.data?.data.totalPosts || 0)
          // setTotalPages(response?.data?.data.totalPages || 0)
        } else {
          setTableData([]);
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setTableData([]);
        console.error("Error fetching user data", error);
      });
  };

  // const changeSearchValue = (e) => {
  //   const newSearchValue = e.target.value;
  //   setSearchValue(newSearchValue);
  // };

  // const handlePageChange = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };

  // const handlePrev = () => {
  //   if (currentPage > 1) {
  //     setCurrentPage(currentPage - 1);
  //   }
  // };

  // const handleNext = () => {
  //   if (currentPage < totalPages) {
  //     setCurrentPage(currentPage + 1);
  //   }
  // };

  const handleDown = async (id) => {
    const textMessage = "Are you sure you want to Down this SMSC?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "warning",
      title: "Confirm Approval",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    // if (result.isConfirmed) {
    //     try {
    //         const response = await approve({ user_id: row.id, approved: true });
    //         if (response?.data?.statusCode === 200) {
    //             const confirmMessage = "The user has been approved successfully.";
    //             SwalWithBootstrapButtons.fire('Approved', confirmMessage, 'success');
    //             // Refetch data here
    //             fetchTableData();
    //         } else {
    //             const confirmMessage = 'Failed to approve user';
    //             SwalWithBootstrapButtons.fire('Error', confirmMessage, 'error');
    //         }
    //     } catch (error) {
    //         console.error('Error approving user', error);
    //         const confirmMessage = "An error occurred while approving the user.";
    //         SwalWithBootstrapButtons.fire('Error', confirmMessage, 'error');
    //     }
    // }
  };
  const handleDelete = async (id) => {
    const usersToBeDeleted = id;
    const textMessage = "Are you sure you want to delete this SMSC?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "success",
      title: "Confirm deletion",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    // if (result.isConfirmed) {
    //   const newUsers = tableData.filter(f => !usersToBeDeleted.includes(f.id));

    //   deleteListApi({ id: ids })
    //     .then((response) => {
    //       if (response?.data?.statusCode === 200) {
    //         setMessage('The List has been deleted.')
    //       } else {
    //         setError('Failed to Delete.');
    //       }
    //     })
    //     .catch((error) => {
    //       setError('Error deleting this list.' || error);
    //     });

    //   { error === '' ? await SwalWithBootstrapButtons.fire('Deleted', message, 'success') : await SwalWithBootstrapButtons.fire('Failed', error, 'error') }

    //   setTableData(newUsers);
    // }
  };

  const canEdit = hasPermission("SMSC List", "edit");
  // const canDownload = hasPermission("SMSC List", "download");
  const canDelete = hasPermission("SMSC List", "delete");

  const TableRow = (props) => {
    return (
      <tr className="border-bottom">
        <td>
          <span className="fw-normal" title={props.name||'-'}>{props.name || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.admin_id||'-'}>{props.admin_id || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.id||'-'}>{props.id || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.status||'-'}>{props.status || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.failed||'-'}>{props.failed || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.queue||'-'}>{props.queue || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.sms_recieved||'-'}>{props.sms_recieved || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.sms_sent||'-'}>{props.sms_sent || "-"}</span>
        </td>
        <td>
          <span className="fw-normal"> title={props.sms_inbound||'-'} {props.sms_inbound || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.sms_outbound||'-'}>{props.sms_outbound || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.dlr_received||'-'}>{props.dlr_received || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.dlr_sent||'-'}>{props.dlr_sent || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.dlr_inbound||'-'}>{props.dlr_inbound || "-"}</span>
        </td>
        <td>
          <span className="fw-normal" title={props.dlr_outbound||'-'}>{props.dlr_outbound || "-"}</span>
        </td>
        {(canEdit || canDelete) && (
          <td>
            <div className="d-flex align-items-center">
            {canEdit && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">Down</Tooltip>}
              >
                <Card.Link
                  className="ms-2 ms-auto"
                  onClick={() => handleDown(props.id)}
                >
                  <IoMdArrowDropdownCircle className="icon icon-xs text-info" />
                </Card.Link>
              </OverlayTrigger>
            )}
            {canDelete && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">Delete</Tooltip>}
              >
                <Card.Link
                  className="ms-2"
                  onClick={() => handleDelete(props.id)}
                >
                  <XCircleIcon className="icon icon-xs text-danger" />
                </Card.Link>
              </OverlayTrigger>
            )}
            </div>
          </td>
        )}
      </tr>
    );
  };

  return (
    <Card border={1}>
      {/* <div className="d-flex mb-3 flex-wrap align-items-center">
            <InputGroup className="me-2 me-lg-3 fmxw-300">
              <InputGroup.Text>
                <SearchIcon className="icon icon-xs" />
              </InputGroup.Text>
              <Form.Control
                type="search"
                placeholder="Search Name/Admin ID/ID"
                value={searchValue}
                onChange={changeSearchValue}
              />
            </InputGroup>

            {canDownload && (
              <Button variant="gray-300" className="ms-auto d-inline-flex me-2">
                <DownloadIcon className="icon icon-xs" />
              </Button>
            )}

            <ButtonGroup className="">
                            <Dropdown>
                                <Dropdown.Toggle split as={Button} variant="link" className="text-dark m-0 p-1">
                                    <CogIcon className="icon icon-sm" />
                                    <span className="visually-hidden">Toggle Dropdown</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end pb-0">
                                    <span className="small ps-3 fw-bold text-dark">Show</span>
                                    {[10, 20, 30].map((limit) => (
                                        <Dropdown.Item
                                            key={limit}
                                            className={`d-flex align-items-center fw-bold ${limit === 30 ? 'rounded-bottom' : ''}`}
                                            onClick={() => {
                                                setPagelimit(limit); // Update the page limit
                                                setCurrentPage(1);  // Reset the page number to 1
                                            }}
                                        >
                                            {limit} {pagelimit === limit && <CheckIcon className="icon icon-xxs ms-auto" />}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </ButtonGroup>
          </div> */}
      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table
            responsive
            className="align-items-center table-flush table-outlines"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">Name</th>
                <th className="border-bottom">Admin ID</th>
                <th className="border-bottom">ID</th>
                <th className="border-bottom">Status</th>
                <th className="border-bottom">Failed</th>
                <th className="border-bottom">Queued</th>
                <th className="border-bottom">SMS Received</th>
                <th className="border-bottom">SMS Sent</th>
                <th className="border-bottom">SMS Inbound</th>
                <th className="border-bottom">SMS Outbound</th>
                <th className="border-bottom">DLR Received</th>
                <th className="border-bottom">DLR Sent</th>
                <th className="border-bottom">DLR Inbound</th>
                <th className="border-bottom">DLR Outbound</th>
                {(canEdit || canDelete) && (
                  <th className="border-bottom">Action</th>
                )}
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => <TableRow key={index} {...u} />)
              ) : (
                <tr>
                  <td colSpan="15" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {/* <Card.Footer className="px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
                                <Nav>
                                    <Pagination className="mb-0">
                                        <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
                                            Previous
                                        </Pagination.Prev>
                                        {currentPage >= 3 && (
                                            <>
                                                <Pagination.Item onClick={() => handlePageChange(1)}>1</Pagination.Item>
                                                <Pagination.Ellipsis />
                                            </>
                                        )}
                                        {currentPage > 1 && (
                                            <Pagination.Item onClick={() => handlePageChange(currentPage - 1)}>
                                                {currentPage - 1}
                                            </Pagination.Item>
                                        )}
                                        <Pagination.Item active>{currentPage}</Pagination.Item>
                                        {currentPage < totalPages && (
                                            <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>
                                                {currentPage + 1}
                                            </Pagination.Item>
                                        )}
                                        {currentPage < totalPages - 1 && (
                                            <>
                                                <Pagination.Ellipsis />
                                                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                                                    {totalPages}
                                                </Pagination.Item>
                                            </>
                                        )}
                                        <Pagination.Next onClick={handleNext} disabled={currentPage === totalPages}>
                                            Next
                                        </Pagination.Next>
                                    </Pagination>
                                </Nav>
                                <small className="fw-normal small mt-2 mt-md-0">
                  Showing <b>{totalPosts==0?totalPosts:pagelimit*(currentPage-1)+1}-{(pagelimit*currentPage)>totalPosts?totalPosts:(pagelimit*currentPage)}</b> of <b>{totalPosts}</b>{" "}entries.
                </small>
                            </Card.Footer> */}
    </Card>
  );
};
